import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Image } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import logo_image from "../imgs/logo.png";
import about_pixia from "../imgs/about_pixia.png";
import about_tehnic_studio from "../imgs/about_tehnic_studio.png";
import about_crm_app from "../imgs/about_crm_app.png";
import about_ge_erp_app from "../imgs/about_ge_erp.jpeg";
import about_ge_crm_app from "../imgs/about_ge_crm.jpeg";
import about_il_crm_app from "../imgs/about_il_crm.png";
import about_ll_crm_app from "../imgs/about_ll_crm.png";
import about_il_erp_app from "../imgs/about_il_erp.png";
import about_ll_erp_app from "../imgs/about_ll_erp.png";

const About = () => {
  const location = useLocation();
  return (
    <Row>
      <Col md={12} style={{display: "flex", justifyContent: "center"}}>
        <div style={{ display: "flex", justifyContent: "center", width: "70%", height: "100%", alignSelf: "center" }}>
          {(location?.state?.applicationName === "PixiaContur") && <Image style={{ width: "100%", height: "100%" }} src={about_pixia} />}
          {(location?.state?.applicationName === "TehnicStudio") && <Image style={{ width: "100%", height: "100%" }} src={about_tehnic_studio} />}
          {(location?.state?.applicationName === "CRMApp") && <Image style={{ width: "100%", height: "100%" }} src={about_crm_app} />}
          {(location?.state?.applicationName === "GE_CRMApp") && <Image style={{ width: "100%", height: "100%" }} src={about_ge_crm_app} />}
          {(location?.state?.applicationName === "GE_ERPApp") && <Image style={{ width: "100%", height: "100%" }} src={about_ge_erp_app} />}
          {(location?.state?.applicationName === "IL_CRMApp") && <Image style={{ width: "100%", height: "100%" }} src={about_il_crm_app} />}
          {(location?.state?.applicationName === "LL_CRMApp") && <Image style={{ width: "100%", height: "100%" }} src={about_ll_crm_app} />}
          {(location?.state?.applicationName === "IL_ERPApp") && <Image style={{ width: "100%", height: "100%" }} src={about_il_erp_app} />}
          {(location?.state?.applicationName === "LL_ERPApp") && <Image style={{ width: "100%", height: "100%" }} src={about_ll_erp_app} />}
        </div>
      </Col>
    </Row>
  );
};

export default About;
